export default "__VITE_ASSET__CbB7jv1m__"